<template xmlns="http://www.w3.org/1999/html">
  <TopNav></TopNav>
  <h1>Gebelik Hesaplama</h1>
  <fieldset>
    <legend>Gebelik Hesaplama Aracı</legend>
    <label for="gebeliktarihi">Döllenme Tarihi:</label> <input type="date" v-model="gebelik" id="gebeliktarihi">
    <br><br>
    Tahmini Doğum Tarihi: <span class="blue">{{ sonrakitarih() }}</span> civarlarında (± 2 hafta).
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'
import moment from 'moment'

export default {
  name: "Gebelik",
  data() {
    return {
      gebelik: new Date(),
      gunValue: 280
    }
  },
  components: {
    TopNav
  },
  methods: {
    sonrakitarih: function () {
      moment.locale('tr')
      return moment(this.gebelik).add(this.gunValue, 'days').format("LL");
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
